module.exports = __webpack_public_path__ + "static/media/plaque_bdl_2022.17cf0828.png";